import { Vue, Component, Ref, Prop, Emit } from 'vue-property-decorator'
import { Nullable } from '@/shared/types/app.types'
import { initialLocalTopographicSubsetLaboratoryModalState, LocalTopographicSubsetLaboratoryModalComboElement, LocalTopographicSubsetLaboratoryModalState } from '@/modules/configurationModule/detail/local-samples/topographic-subset-laboratory/components/topographic-subset-laboratory-modal/topographic-subset-laboratory-modal.model'
import { ConfigurationTopographicSubsetLaboratoryCreateRequest, ConfigurationTopographicSubsetLaboratoryPatchInBatchRequest, ConfigurationTopographicSubsetLaboratoryResponse } from '@/modules/configurationModule/detail/local-samples/topographic-subset-laboratory/services/topographic-subset-laboratory.dto'
import { commonTopographicCodeService } from '@/api/services/common/topographic-code/common-topographic-code.service'
import { CommonTopographicCodeResponse } from '@/api/services/common/topographic-code/common-topographic-code.dto'
import { BModal } from 'bootstrap-vue'

@Component
export default class LocalTopographicSubsetLaboratoryModal extends Vue {
    @Ref() readonly localTopographicSubsetLaboratoryModal!: BModal
    @Prop(String) readonly actionTitle!: string
    @Prop(Number) readonly laboratoryId!: number
    @Emit()
    update(localSampleTypePatch: ConfigurationTopographicSubsetLaboratoryPatchInBatchRequest[]): ConfigurationTopographicSubsetLaboratoryPatchInBatchRequest[] {
        return localSampleTypePatch
    }
    @Emit()
    create(localSampleTypeCreate: ConfigurationTopographicSubsetLaboratoryCreateRequest): ConfigurationTopographicSubsetLaboratoryCreateRequest {
        return localSampleTypeCreate
    }

    state: LocalTopographicSubsetLaboratoryModalState
    constructor() {
        super()
        this.state = initialLocalTopographicSubsetLaboratoryModalState()
    }

    get canUpdateCombo(): boolean {
        return !this.state?.id
    }

    get canUpdate(): boolean {
        const hasError: boolean = !!this.errors.count()
        const anyFieldIsDirty = this.$_someFieldIsDirty(this.fields)
        const comboSelectionValid = !!this.state.topographicCodeSelected?.id
        return !hasError && anyFieldIsDirty && comboSelectionValid
    }

    async show(selectedRow: Nullable<ConfigurationTopographicSubsetLaboratoryResponse>): Promise<void> {
        this.state = initialLocalTopographicSubsetLaboratoryModalState()
        await this.$validator.reset()
        if (selectedRow) {
            this._setSelectedRow(selectedRow)
            await this._setSelectedCombo(selectedRow)
        }
        this.localTopographicSubsetLaboratoryModal.show()
    }

    hide(): void { this.localTopographicSubsetLaboratoryModal.hide() }

    updateRow(selectedRow: Nullable<ConfigurationTopographicSubsetLaboratoryResponse>): void {
        this._setSelectedRow(selectedRow)
    }

    spreadEvent(): void {
        if (this.state?.id) {
            const patchRow: ConfigurationTopographicSubsetLaboratoryPatchInBatchRequest = {
                id: this.state.id,
                active: this.state.active
            }
            this.update([patchRow])
            return
        }
        const postRow: ConfigurationTopographicSubsetLaboratoryCreateRequest = {
            active: this.state.active,
            topographicCodeId: this.state.topographicCodeSelected?.id!
        }
        this.create(postRow)
    }

    async searchService(query: string): Promise<LocalTopographicSubsetLaboratoryModalComboElement[]> {
        let content = []
        if (query) {
            const [err, response] = await this.$_toCall(commonTopographicCodeService.searchTopographicCodes({
                query,
                size: 20
            }), true)
            if (err) {
                return []
            }
            content = response.map((topographicCode: CommonTopographicCodeResponse) => {
                return {
                    id: topographicCode.id,
                    text: topographicCode.description
                }
            })
        }
        return content
    }

    private _setSelectedRow(selectedRow: Nullable<ConfigurationTopographicSubsetLaboratoryResponse>): void {
        this.state = {
            ...this.state,
            id: selectedRow?.id,
            active: selectedRow?.active!,
            topographicCodeId: selectedRow?.topographicCode.id
        }
    }

    private async _setSelectedCombo(selectedRow: ConfigurationTopographicSubsetLaboratoryResponse): Promise<void> {
        const listElements = await this.searchService(selectedRow.topographicCode.description)
        const foundElementInList = listElements.find((itemList: LocalTopographicSubsetLaboratoryModalComboElement) => itemList.id === this.state.topographicCodeId)
        if (foundElementInList) {
            this.state.topographicCodeSelected = foundElementInList
        }
    }
}
